import { setDialogVisible } from "../../actions";
import { removeExtension, setExtensionEnabled, setExtensionEndorsed, } from "../../actions/app";
import Dropzone from "../../controls/Dropzone";
import FlexLayout from "../../controls/FlexLayout";
import IconBar from "../../controls/IconBar";
import Table from "../../controls/Table";
import ToolbarIcon from "../../controls/ToolbarIcon";
import { relaunch } from "../../util/commandLine";
import { ComponentEx, connect, translate } from "../../controls/ComponentEx";
import { log } from "../../util/log";
import * as selectors from "../../util/selectors";
import { getSafe } from "../../util/storeHelper";
import MainPage from "../../views/MainPage";
import { SITE_ID } from "../gamemode_management/constants";
import installExtension from "./installExtension";
import getTableAttributes from "./tableAttributes";
import PromiseBB from "bluebird";
import * as _ from "lodash";
import * as path from "path";
import * as React from "react";
import { Alert, Button, Panel } from "react-bootstrap";
class ExtensionManager extends ComponentEx {
    staticColumns;
    actions;
    constructor(props) {
        super(props);
        this.initState({
            oldExtensionConfig: props.extensionConfig,
            showBundled: false,
        });
        this.actions = [
            {
                icon: "delete",
                title: "Remove",
                action: this.removeExtension,
                condition: (instanceId) => !this.props.extensions[instanceId].bundled,
                singleRowAction: true,
            },
        ];
        this.staticColumns = getTableAttributes({
            onSetExtensionEnabled: (extName, enabled) => {
                const { extensions, onSetExtensionEnabled } = this.props;
                const extId = Object.keys(extensions).find((iter) => extensions[iter].name === extName);
                log("info", "user toggling extension manually", { extId, enabled });
                onSetExtensionEnabled(extId, enabled);
            },
            onToggleExtensionEnabled: (extName) => {
                const { extensionConfig, extensions, onSetExtensionEnabled } = this.props;
                const extId = Object.keys(extensions).find((iter) => extensions[iter].name === extName);
                const enabled = !getSafe(extensionConfig, [extId, "enabled"], true);
                log("info", "user toggling extension manually", { extId, enabled });
                onSetExtensionEnabled(extId, enabled);
            },
            onEndorseMod: (gameId, modIdStr, endorseState) => {
                const { extensions } = this.props;
                const { api } = this.context;
                const modId = parseInt(modIdStr, 10);
                const extId = Object.keys(extensions).find((iter) => extensions[iter].modId === modId);
                if (extId === undefined) {
                    return;
                }
                api
                    .emitAndAwait("endorse-nexus-mod", SITE_ID, modId, extensions[extId].version, endorseState)
                    .then((endorsed) => {
                    api.store.dispatch(setExtensionEndorsed(extId, endorsed[0]));
                })
                    .catch(() => {
                    api.store.dispatch(setExtensionEndorsed(extId, "Undecided"));
                });
            },
        });
    }
    render() {
        const { t, extensions, localState, extensionConfig } = this.props;
        const { oldExtensionConfig, showBundled } = this.state;
        const extensionsWithState = this.mergeExt(extensions, extensionConfig, showBundled);
        // normalize extension config so they differ only if the effective configuration actually
        // differs, leaving out the endorsement state
        const configId = (conf) => Object.values(conf).map((ext) => ({
            enabled: ext.enabled ?? true,
            version: ext.version ?? "",
            remove: ext.remove ?? false,
        }));
        return (React.createElement(MainPage, null,
            React.createElement(MainPage.Header, null,
                React.createElement(IconBar, { id: "extensions-layout-list", group: "extensions-layout-icons", staticElements: [], className: "menubar", t: t },
                    React.createElement(ToolbarIcon, { id: "show-bundled-extensions", text: showBundled ? t("Hide Bundled") : t("Show Bundled"), onClick: this.toggleBundled, icon: showBundled ? "hide" : "show", tooltip: showBundled
                            ? t("Hide Bundled Extensions")
                            : t("Show Bundled Extensions") }))),
            React.createElement(MainPage.Body, null,
                React.createElement(Panel, null,
                    React.createElement(Panel.Body, null,
                        React.createElement(FlexLayout, { type: "column" },
                            React.createElement(FlexLayout.Fixed, null, localState.reloadNecessary ||
                                !_.isEqual(configId(extensionConfig), configId(oldExtensionConfig))
                                ? this.renderReload()
                                : null),
                            React.createElement(FlexLayout.Flex, null,
                                React.createElement(Table, { tableId: "extensions", data: extensionsWithState, actions: this.actions, staticElements: this.staticColumns, multiSelect: false })),
                            React.createElement(FlexLayout.Fixed, null,
                                React.createElement(FlexLayout, { type: "row" },
                                    React.createElement(FlexLayout.Flex, { className: "extensions-find-button-container" },
                                        React.createElement("div", { className: "flex-center-both" },
                                            React.createElement(Button, { id: "btn-more-extensions", onClick: this.onBrowse, bsStyle: "ghost" }, t("Find more")))),
                                    React.createElement(FlexLayout.Flex, null,
                                        React.createElement(Dropzone, { accept: ["files"], drop: this.dropExtension, dialogHint: t("Select extension file"), icon: "folder-download" }))))))))));
    }
    onBrowse = () => {
        this.props.onBrowseExtension();
    };
    toggleBundled = () => {
        this.nextState.showBundled = !this.state.showBundled;
    };
    dropExtension = (type, extPaths) => {
        const { downloads } = this.props;
        let success = false;
        log("info", "installing extension(s) via drag and drop", { extPaths });
        const prop = type === "files"
            ? PromiseBB.map(extPaths, (extPath) => installExtension(this.context.api, extPath)
                .then(() => {
                success = true;
            })
                .catch((err) => {
                this.context.api.showErrorNotification("Failed to install extension", err, { allowReport: false });
            }))
            : PromiseBB.map(extPaths, (url) => new PromiseBB((resolve, reject) => {
                this.context.api.events.emit("start-download", [url], undefined, (error, id) => {
                    const dlPath = path.join(this.props.downloadPath, downloads[id].localPath);
                    installExtension(this.context.api, dlPath)
                        .then(() => {
                        success = true;
                    })
                        .catch((err) => {
                        this.context.api.showErrorNotification("Failed to install extension", err, { allowReport: false });
                    })
                        .finally(() => {
                        resolve();
                    });
                });
            }));
        prop.then(() => {
            if (success) {
                this.props.updateExtensions();
            }
        });
    };
    renderReload() {
        const { t } = this.props;
        return (React.createElement(Alert, { bsStyle: "warning", style: { display: "flex", alignItems: "center" } },
            React.createElement("div", { style: { flexGrow: 1 } }, t("You need to restart Vortex to apply changes.")),
            React.createElement(Button, { onClick: this.restart }, t("Restart"))));
    }
    restart = () => {
        relaunch();
    };
    mergeExt(extensions, extensionConfig, includeBundled) {
        const { loadFailures } = this.props;
        return Object.keys(extensions).reduce((prev, id) => {
            if (!includeBundled && extensions[id].bundled) {
                return prev;
            }
            if (!getSafe(extensionConfig, [id, "remove"], false)) {
                const enabled = loadFailures[id] === undefined
                    ? getSafe(extensionConfig, [id, "enabled"], true)
                    : "failed";
                const endorsed = getSafe(extensionConfig, [id, "endorsed"], "Undecided");
                prev[id] = {
                    ...extensions[id],
                    enabled,
                    endorsed,
                    loadFailures: loadFailures[id] || [],
                };
            }
            return prev;
        }, {});
    }
    removeExtension = (extIds) => {
        extIds.forEach((extId) => {
            const ext = this.props.extensions[extId];
            this.props.onRemoveExtension(path.basename(ext.path || extId));
        });
    };
}
const emptyObject = {};
function mapStateToProps(state) {
    return {
        // TODO: don't use || {} in mapStateToProps because {} is always a new object and
        //   thus causes constant re-drawing. but when removing this, make sure no access
        //   to undefined can happen
        extensionConfig: state.app.extensions || emptyObject,
        loadFailures: state.session.base.extLoadFailures,
        downloads: state.persistent.downloads.files,
        downloadPath: selectors.downloadPath(state),
        extensions: state.session.extensions.installed,
    };
}
function mapDispatchToProps(dispatch) {
    return {
        onSetExtensionEnabled: (extId, enabled) => dispatch(setExtensionEnabled(extId, enabled)),
        onRemoveExtension: (extId) => dispatch(removeExtension(extId)),
        onBrowseExtension: () => dispatch(setDialogVisible("browse-extensions")),
    };
}
export default translate(["common"])(connect(mapStateToProps, mapDispatchToProps)(ExtensionManager));
